<template>
   <v-container class="pt-1 pb-12 py-sm-12 px-4 px-sm-0">

    <!-- Header Desktop -->
  <v-row class="d-none d-sm-flex mb-4">
  <v-col cols="12">
    <div class="title-container">
      <div class="title-block">
    <div class="d-flex align-center ga-3">
        <span class="page-title">{{ isEdicao ? 'Editar Preço Dinâmico' : 'Preço Dinâmico' }}</span>
    <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on, attrs }">
            <v-btn small color="primary" text v-bind="attrs" v-on="on">
                <v-icon left>mdi-help-circle-outline</v-icon>Ajuda
            </v-btn>
        </template>
        <v-card min-width="380px">
            <v-card-title class="text-h6 font-weight-bold pb-2">
                <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-3 pb-3">
                <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📅 Data de início</p><p class="text-caption grey--text">A partir de quando esse preço começa a valer</p></div>
                <v-divider class="my-2"></v-divider>
                <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📅 Data de término</p><p class="text-caption grey--text">Até quando esse preço é válido. Deixe em branco para não ter fim</p></div>
                <v-divider class="my-2"></v-divider>
                <div class="mb-3"><p class="font-weight-bold text-caption mb-1">⏰ Horário de início</p><p class="text-caption grey--text">A partir de que hora do dia o preço entra em vigor</p></div>
                <v-divider class="my-2"></v-divider>
                <div class="mb-3"><p class="font-weight-bold text-caption mb-1">⏰ Horário de término</p><p class="text-caption grey--text">Até que hora do dia o preço é aplicado</p></div>
                <v-divider class="my-2"></v-divider>
                <div class="mb-3"><p class="font-weight-bold text-caption mb-1">💵 Valor</p><p class="text-caption grey--text">Quanto o cliente vai pagar durante esse período</p></div>
                <v-divider class="my-2"></v-divider>
                <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📆 Dias da semana</p><p class="text-caption grey--text">Em quais dias esse preço é aplicado</p></div>
                <v-divider class="my-2"></v-divider>
                <div><p class="font-weight-bold text-caption mb-1">🖥️ Máquinas</p><p class="text-caption grey--text">Quais máquinas vão usar esse preço</p></div>
            </v-card-text>
        </v-card>
    </v-menu>
    </div>
     <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
          { text: 'Homepage', disabled: false, to: '/home', exact: true },
          { text: 'Preço Dinâmico', disabled: false, to: '/preco-dinamico', exact: true }
        ]" />
</div>
      <div class="button-group">
     <v-btn elevation="0" color="primary" outlined dark @click="voltar">
  Voltar
</v-btn>
<v-btn elevation="0" color="primary" dark @click="salvar" :loading="loading">
  Salvar
</v-btn>
      </div>
    </div>
  </v-col>
</v-row>

<!-- Header Mobile -->
<v-row class="d-sm-none mb-4">
  <v-col cols="12">
    <div class="title-block">
  <div class="d-flex align-center">
    <span class="page-title">{{ isEdicao ? 'Editar Preço Dinâmico' : 'Preço Dinâmico' }}</span>
    <v-btn icon small color="primary" class="ml-2" @click="dialogAjudaMobile = true">
        <v-icon>mdi-help-circle-outline</v-icon>
    </v-btn>
</div>
    <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
      { text: 'Homepage', disabled: false, to: '/home', exact: true },
      { text: 'Preço Dinâmico', disabled: false, to: '/preco-dinamico', exact: true }
    ]" />
</div>
  <div class="button-group mt-2">
  <v-btn elevation="0" color="primary" outlined dark @click="voltar" block>
    Voltar
  </v-btn>
  <v-btn elevation="0" color="primary" dark @click="salvar" :loading="loading" block>
    Salvar
  </v-btn>
</div>
  </v-col>
</v-row>

<v-form ref="form" v-model="formValido">
  <v-row dense>

    <v-col cols="12" sm="6" class="mb-3">
    <v-text-field
      v-model="form.dataInicio"
      type="date"
      label="Data de início"
      dense
      outlined
      :rules="[$rules.required]"
      hide-details="auto"
    />
  </v-col>

  <v-col cols="12" sm="6" class="mb-3">
    <v-text-field
      v-model="form.dataFim"
      type="date"
      label="Data de término"
      dense
      outlined
      hide-details="auto"
    />
  </v-col>

  <v-col cols="12" sm="6" class="mb-3">
    <v-text-field
      v-model="form.horaInicio"
      type="time"
      label="Horário de início"
      dense
      outlined
      :rules="[$rules.required]"
      hide-details="auto"
    />
  </v-col>

  <v-col cols="12" sm="6" class="mb-3">
    <v-text-field
      v-model="form.horaFim"
      type="time"
      label="Horário de término"
      dense
      outlined
      :rules="[$rules.required]"
      hide-details="auto"
    />
  </v-col>

    <!-- Valor -->
    <v-col cols="12" sm="6" class="mb-3">
      <v-text-field
        v-model="form.valor"
        label="Valor (R$)"
        placeholder="0,00"
        dense
        outlined
        @input="formatarValor"
      />
    </v-col>


     <v-col v-if="resumoPrecoDinamico" cols="12" class="mb-3">
      <v-card class="card-form-outlined">
        <v-card-title class="card-group-title">
          <v-icon small class="mr-2">mdi-eye-outline</v-icon>Resumo do preço dinâmico
        </v-card-title>
        <v-card-text>
          <p class="text-body-2">{{ resumoPrecoDinamico }}</p>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Dias da semana -->
    <v-col cols="12">
      <v-card outlined>
        <v-card-title class="section-label">Dias da semana</v-card-title>
        <v-card-text>
          <div style="display:flex; flex-wrap:wrap; gap:8px; align-items:center;">
            <div
              v-for="dia in diasSemanaOpcoes"
              :key="dia.value"
              @click="toggleDia(dia.value)"
              :style="{
                padding: '4px 12px',
                borderRadius: '20px',
                fontSize: '12px',
                cursor: 'pointer',
                border: '1px solid',
                borderColor: form.diaDaSemana.indexOf(dia.value) !== -1 ? '#1976D2' : '#ccc',
                background: form.diaDaSemana.indexOf(dia.value) !== -1 ? '#1976D2' : 'transparent',
                color: form.diaDaSemana.indexOf(dia.value) !== -1 ? '#fff' : '#555',
                userSelect: 'none'
              }"
            >
              {{ dia.label }}
            </div>
            <v-btn text color="primary" x-small @click="toggleTodosDias">Todos</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Máquinas -->
    <v-col cols="12">
      <v-card outlined>
        <v-card-title class="section-label">Máquinas</v-card-title>
        <v-card-text>
          <div v-if="maquinasDisponiveis.length === 0" style="font-size:13px; color:#aaa; margin-bottom:12px;">
            Nenhuma máquina disponível.
          </div>
          <div
            v-for="maq in maquinasDisponiveis"
            :key="maq.id"
            class="d-flex align-center mb-2"
            style="gap:10px; cursor:pointer;"
            @click="toggleMaquina(maq.id)"
          >
            <v-icon :color="form.maquinaIds.indexOf(maq.id) !== -1 ? 'primary' : 'grey lighten-1'">
              {{ form.maquinaIds.indexOf(maq.id) !== -1 ? 'mdi-checkbox-marked-circle' : 'mdi-checkbox-blank-circle-outline' }}
            </v-icon>
            <span style="font-size:14px; color:#333;">{{ maq.nome }}</span>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

  </v-row>
</v-form>

<v-dialog v-model="dialogConfirmar" max-width="400">
  <v-card>
    <v-card-title>{{ isEdicao ? 'Atualizar Preço Dinâmico' : 'Adicionar Preço Dinâmico' }}</v-card-title>
    <v-card-text>{{ isEdicao ? 'Deseja atualizar o preço dinâmico?' : 'Deseja adicionar o preço dinâmico?' }}</v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text @click="dialogConfirmar = false">Cancelar</v-btn>
      <v-btn style="background-color: #3BA5DB !important; color: white !important;" @click="confirmarSalvar">{{ isEdicao ? 'Atualizar' : 'Adicionar' }}</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" top right>
      {{ snackbar.text }}
    </v-snackbar>
<v-dialog v-model="dialogAjudaMobile" scrollable content-class="popup-mobile-dialog">
    <v-card>
        <div class="popup-mobile-header">
            <span class="popup-mobile-header-title">
                <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
            </span>
            <v-btn icon small class="popup-mobile-close" @click="dialogAjudaMobile = false">
                <v-icon size="18">mdi-close</v-icon>
            </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="pt-3 pb-3">
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📅 Data de início</p><p class="text-caption grey--text">A partir de quando esse preço começa a valer</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📅 Data de término</p><p class="text-caption grey--text">Até quando esse preço é válido. Deixe em branco para não ter fim</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">⏰ Horário</p><p class="text-caption grey--text">Em que horário do dia o preço é aplicado</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">💵 Valor</p><p class="text-caption grey--text">Quanto o cliente vai pagar durante esse período</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📆 Dias da semana</p><p class="text-caption grey--text">Em quais dias esse preço é aplicado</p></div>
            <v-divider class="my-2"></v-divider>
            <div><p class="font-weight-bold text-caption mb-1">🖥️ Máquinas</p><p class="text-caption grey--text">Quais máquinas vão usar esse preço</p></div>
        </v-card-text>
    </v-card>
</v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import { eventHub } from "@/main"

export default {
  name: 'PrecoDinamicoForm',

  data: function () {
    return {
      dialogConfirmar: false,
dialogAjudaMobile: false,
      formValido: true,
      loading: false,
      form: {
        dataInicio: null,
        dataFim: null,
        horaInicio: null,
        horaFim: null,
        valor: null,
        diaDaSemana: [], 
        maquinaIds: []   
      },
      diasSemanaOpcoes: [
        { label: 'Dom', value: 'DOMINGO' },
        { label: 'Seg', value: 'SEGUNDA' },
        { label: 'Ter', value: 'TERCA' },
        { label: 'Qua', value: 'QUARTA' },
        { label: 'Qui', value: 'QUINTA' },
        { label: 'Sex', value: 'SEXTA' },
        { label: 'Sáb', value: 'SABADO' }
      ],
      // Lista de máquinas disponíveis vindas do back-end
   maquinasDisponiveis: [],
      snackbar: { show: false, text: '', color: 'success' },
    }
  },

  computed: {
    isEdicao: function () {
      return this.$route.params.id && this.$route.params.id !== 'novo'
    },

    resumoPrecoDinamico() {
      const f = this.form;
      if (!f.valor && !f.dataInicio && f.diaDaSemana.length === 0) return null;

      let partes = [];

      if (f.valor) partes.push(`O preço vai para R$ ${f.valor}`);

      if (f.dataInicio && f.dataFim) {
        const ini = f.dataInicio.split('-').reverse().join('/');
        const fim = f.dataFim.split('-').reverse().join('/');
        partes.push(`de ${ini} até ${fim}`);
      } else if (f.dataInicio) {
        const ini = f.dataInicio.split('-').reverse().join('/');
        partes.push(`a partir de ${ini}`);
      }

      if (f.horaInicio && f.horaFim) partes.push(`no horário das ${f.horaInicio} às ${f.horaFim}`);

      if (f.diaDaSemana.length === 7) {
        partes.push('todos os dias da semana');
      } else if (f.diaDaSemana.length > 0) {
        const nomes = { DOMINGO:'aos domingos', SEGUNDA:'às segundas', TERCA:'às terças', QUARTA:'às quartas', QUINTA:'às quintas', SEXTA:'às sextas', SABADO:'aos sábados' };
        const dias = f.diaDaSemana.map(d => nomes[d]);
        const ultimo = dias.pop();
        partes.push((dias.length ? dias.join(', ') + ' e ' : '') + ultimo);
      }

      if (f.maquinaIds.length > 0) {
        const nomes = this.maquinasDisponiveis.filter(m => f.maquinaIds.indexOf(m.id) !== -1).map(m => m.nome);
        partes.push(`nas máquinas: ${nomes.join(', ')}`);
      }

      return partes.join(', ') + '.';
    }
  },

  mounted: function() {
  eventHub.$on('CHANGE-OPERATION', () => {
    this.$router.push('/preco-dinamico');
  });
  this.carregarMaquinas();
  if (this.isEdicao) this.carregarDados();
},
destroyed: function() {
  eventHub.$off('CHANGE-OPERATION');
},

  methods: {
   carregarDados: async function () {
  try {
    var result = await axios.get('/api/preco-dinamico/' + this.$route.params.id)
    var val = result.data
    this.form = {
      dataInicio: val.dataInicio || null,
      dataFim: val.dataFim || null,
      horaInicio: val.horaInicio || null,
      horaFim: val.horaFim || null,
      valor: val.valor ? String(parseFloat(val.valor).toFixed(2)).replace('.', ',') : null,
      // Mapeando do back-end para os novos nomes do form
      diaDaSemana: val.diaDaSemana ? val.diaDaSemana.slice() : [],
      maquinaIds: val.maquinas ? val.maquinas.map(function(m) { return m.id }) : []
    }
  } catch (error) {
    this.mostrarSnackbar('Erro ao carregar dados', 'error')
  }
},

 carregarMaquinas: async function () {
  try {
    // 1. Busca da API (certifique-se de passar o operacaoId se necessário)
    const operacaoId = localStorage.getItem('operation');
    const res = await axios.get('/api/maquina', { params: { operacaoId } });
    
    const maquinasBrutas = res.data || [];

    // 2. Formata a lista para exibir "10 (LAVAR)" no formulário
this.maquinasDisponiveis = maquinasBrutas.map(m => ({
  ...m,
  nome: m.nome + ' (' + m.tipo + ')'
}));
  } catch (e) {
    console.error("Erro ao carregar máquinas", e);
    // Remova aqueles IDs '1', '2' fixos daqui, eles só atrapalham
    this.maquinasDisponiveis = [];
  }
},


    // ── Dias da semana ──────────────────────────────────────
toggleDia: function (dia) {
  var i = this.form.diaDaSemana.indexOf(dia)
  if (i === -1) {
    this.form.diaDaSemana.push(dia)
  } else {
    this.form.diaDaSemana.splice(i, 1)
  }
},

toggleTodosDias: function () {
  if (this.form.diaDaSemana.length === this.diasSemanaOpcoes.length) {
    this.form.diaDaSemana = []
  } else {
    this.form.diaDaSemana = this.diasSemanaOpcoes.map(function (d) { return d.value })
  }
},

// Máquinas
toggleMaquina: function (id) {
  var i = this.form.maquinaIds.indexOf(id)
  if (i === -1) {
    this.form.maquinaIds.push(id)
  } else {
    this.form.maquinaIds.splice(i, 1)
  }
},
    // ── Valor ───────────────────────────────────────────────
formatarValor: function (v) {
  if (!v) {
    this.form.valor = ''
    return
  }

  // Mantém apenas números
  let limpo = v.replace(/\D/g, '')

  // Se vazio (ex: apagou tudo), limpa o model
  if (!limpo) {
    this.form.valor = ''
    return
  }

  // Lógica de centavos: divide por 100 e fixa 2 casas
  // Ex: "1" -> 0.01 -> "0,01"
  let centavos = (parseInt(limpo) / 100).toFixed(2)
  this.form.valor = centavos.replace('.', ',')
},


    // ── Navegação / Salvar ──────────────────────────────────
    voltar: function () {
      this.$router.push('/preco-dinamico')
    },

  salvar: function () {
  if (!this.$refs.form.validate()) return
  this.dialogConfirmar = true
},

confirmarSalvar: async function () {
  this.dialogConfirmar = false
  this.loading = true
  try {
    const operacaoId = localStorage.getItem('operation')
    const payload = {
      dataInicio: this.form.dataInicio,
      dataFim: this.form.dataFim,
      horaInicio: this.form.horaInicio,
      horaFim: this.form.horaFim,
      valor: parseFloat(String(this.form.valor).replace(',', '.')),
      diaDaSemana: this.form.diaDaSemana,
      operacaoId,
      maquinas: this.form.maquinaIds.map(function(id) { return { id: id } })
    }

    if (this.isEdicao) {
      await axios.put('/api/preco-dinamico/' + this.$route.params.id, payload)
    } else {
      await axios.post('/api/preco-dinamico', payload)
    }
    this.mostrarSnackbar('Salvo com sucesso!')
    this.$router.push('/preco-dinamico')
  } catch (error) {
    const data = error.response && error.response.data
    if (data && data.campos) {
      const primeiroCampo = Object.values(data.campos)[0]
      this.mostrarSnackbar(primeiroCampo, 'error')
    } else {
      this.mostrarSnackbar((data && data.mensagem) || 'Erro ao salvar', 'error')
    }
  } finally {
    this.loading = false
  }
},

    mostrarSnackbar: function (text, color) {
      this.snackbar.text = text
      this.snackbar.color = color || 'success'
      this.snackbar.show = true
    }
  }
}
</script>

<style scoped>
.section-label {
  font-size: 13px !important;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-bottom: 0;
}
.popup-mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px 16px;
}

.popup-mobile-header-title {
  font-size: 17px;
  font-weight: 700;
  color: #333;
  display: flex;
  align-items: center;
}

.popup-mobile-close.v-btn {
  background-color: #f0f0f0 !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  box-shadow: none !important;
}

.popup-mobile-close.v-btn .v-icon {
  color: #555 !important;
}

.popup-mobile-dialog {
  border-radius: 12px;
}
</style>